import { render, staticRenderFns } from "./polygonOperate.vue?vue&type=template&id=27aee42f&"
import script from "./polygonOperate.vue?vue&type=script&lang=ts&"
export * from "./polygonOperate.vue?vue&type=script&lang=ts&"
import style0 from "./polygonOperate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports